import axios from "axios";
import { API_END_POINT } from "../../../constants/api";
import { returnErrors, clearErrors } from "../errorAction";
import { DELETE_ADD_PROGRAM, ADD_PROGRAM, PROGRAM_HISTORY } from "../../Types";

export function addProgramReg(params) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${params.token}`,
      },
    };

    const body = JSON.stringify(params);

    axios
      .post(
        `${API_END_POINT}/api/sizer/program/register`,
        body,
        config
      )
      .then((res) =>
        dispatch({
          type: ADD_PROGRAM,
          payload: res.data,
        })
      )
      .then((data) =>
        dispatch(
          clearErrors("Add Program Successfully", 201, "ADD_PROGRAM_SUCCESS")
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "ADD_PROGRAM_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}
export function deleteAddProgram(add_program_id, company_id, token) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .delete(
        `${API_END_POINT}/api/sizer/program/delete/${add_program_id}/${company_id}`,
        config
      )
      .then((res) =>
        dispatch({
          type: DELETE_ADD_PROGRAM,
          payload: res.data[0],
        })
      )
      .then((data) =>
        dispatch(
          clearErrors(
            "Program Delete Successfully",
            201,
            "PROGRAM_DELETE_SUCCESS"
          )
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "PROGRAM_DELETE_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}

export function programHistory(company_id, token) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(
        `${API_END_POINT}/api/sizer/sizer-program-yarn-history/get/${company_id}`,
        config
      )
      .then((res) =>
        dispatch({
          type: PROGRAM_HISTORY,
          payload: res.data,
        })
      )
      .then((data) =>
        dispatch(
          clearErrors(
            "Get Program History Successfully",
            201,
            "PROGRAM_HISTORY_SUCCESS"
          )
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "PROGRAM_HISTORY_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}
